<template>
  <div class="column is-4 video-item">
    <div class="is-relative">
      <img :src="rootPath + item.ch" :alt="item.longtitle" />
      <div class="is-overlay">
        <a href="#" class="close" @click="remove(item)">&Cross;</a>
      </div>
    </div>
    <strong>{{ item.pagetitle }}</strong>
    <span>({{ index }})</span>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    index: Number
  },
  computed: {
    rootPath() {
      return `${process.env.VUE_APP_ROOT_PATH}`;
    }
  },
  methods: {
    remove(video) {
      this.$store.dispatch("removeVideo", video);
    }
  }
};
</script>

<style lang="scss">
.video-item {
  cursor: pointer;
  &:hover {
    .is-overlay {
      background-color: rgba(72, 199, 116, 0.5);
      transition: background-color 0.3s ease;
    }
  }

  .close {
    font-size: 2rem;
    color: rgba(240, 10, 10, 0.6);
    position: absolute;
    top: 0;
    right: 0;
    line-height: 1rem;
    transition: all 0.3s ease;
    &:hover {
      font-size: 2.5rem;
      color: rgba(240, 10, 10, 0.8);
    }
  }
}
</style>
